import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { FirestoreService } from './firestore/firestore.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/mergeMap';

import { Globals } from '../globals';

export interface Bank {
  active: boolean;
  createdAt: any;
  updatedAt: any;

  bankName: string;
  accountNumber: string;
  CLABE: string;
  isIncome: boolean;
  isOutcome: boolean;
  currency: string;

  adjustedBalance?: number;
  adjustedBalanceDatetime?: string;
  adjustedBalanceSnapshots?: { userId: string, datetime: string, balance: number, previousBalance: number }[];
}

export interface BankId extends Bank {
  id: string;
}


export interface BankTransfer {
  //id: string;
  originBankId: BankId['id'];
  destinationBankId: BankId['id'];
  involvedBankIds: BankId['id'][];
  datetime: string;
  amount: number;
}

@Injectable()
export class BankService {

  bankCollection: AngularFirestoreCollection<Bank>;
  banks: any;

  bankDocument: AngularFirestoreDocument<BankId>;
  bank: Observable<BankId>;

  collection: string = Globals.BANK_COLLECTION;
  bankTransferCollection: string = Globals.BANK_TRANSFER_COLLECTION;

  // NOTE: Change this any for Bank Interface
  bank$: Observable<any>;
  banks$: Observable<any[]>;

  constructor(
    private afs: AngularFirestore,
    private afh: FirestoreService,
    private router: Router
  ) {
    //this.collection = Globals.BANK_COLLECTION;
  }

  /**
   * Get all banks with references
   * @return {Observable} Arrays of banks
   */
  getBanks() {
    return this.afh.colWithIds$(this.collection, ref => ref.where('active', '==', true) );
  }

  /**
  * Get bank data
  * @param {string} sid - The id of the bank
  * @return {Observable} The Bank Object
  */
  getBank(sid: string) {
    return this.afh.docWithIds$(this.collection + '/' + sid);
  }

  /**
  * Create new bank
  * @param {Bank} bank - The data of the bank
  */
  addBank(bank: Bank) {
    this.afh.add(`${this.collection}`, bank);
  }

  /**
   * Update current bank
   * @param {string} sid  - The id of the bank
   * @param {Bank} bank - The data of the bank
   */
  updateBank(sid: string, bank: Partial<Bank>) {
    return this.afh.update(`${this.collection}/${sid}`, bank);
  }

  /**
   * Delete current bank
   * @param {string} sid - The id of the bank
   */
  deleteBank(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

  async addBankTransfer(bankTransfer: BankTransfer): Promise<{ id: string }> {
    let { id } = await this.afs.collection(this.bankTransferCollection).add(bankTransfer);
    return { id };
  }
  getBankTransfers$({ originBankId = '', destinationBankId = '', /* involvedBankId = '', */ datetimeAfter = '' } = {}): Observable<BankTransfer[]> {
    return this.afh.colWithIds$(this.bankTransferCollection, ref => {
      let newRef = ref;
      if(originBankId) newRef = newRef.where('originBankId', '==', originBankId);
      if(destinationBankId) newRef = newRef.where('destinationBankId', '==', destinationBankId);
      //if(involvedBankId) newRef = newRef.where('involvedBankIds', 'array-contains', involvedBankId);
      if(datetimeAfter) newRef = newRef.where('datetime', '>=', datetimeAfter);
      return newRef;
    });
  }

  windowReplace(action: string, id?: string){
    switch(action){
      case 'add':
      case 'create':
        this.router.navigate([`/new_bank`]);
        break;
      case 'edit':
      case 'update':
        this.router.navigate([`/edit_bank/${id}`]);
        break;
      case 'view':
      case 'display':
        this.router.navigate([`/vw_bank/${id}`]);
        break;
      case 'read':
        this.router.navigate([`/bank`]);
        break;
      default:
        console.log('Not an action');
    }
  }
}

export class BankData {

  currencies = {
    'mexicanPeso': new Currency('Peso mexicano', 'MXP'),
    'americanDolar': new Currency('Dólar americano','USD'),
    'euro': new Currency('Euro','EUR')
  }

  bankSelect = [
    {name: 'Seleccione una opción', value: ''},
    {name: 'Banamex', value: 'Banamex'},
    {name: 'BBVA Bancomer', value: 'BBVA Bancomer'},
    {name: 'Banorte', value: 'Banorte'},
    {name: 'Santander', value: 'Santander'},
    {name: 'BanBajío', value: 'BanBajío'},
    {name: 'HSBC', value: 'HSBC'},
    {name: 'Caja Chica', value: 'Caja Chica'},
    {name: 'American Express', value: 'American Express'},
    {name: 'Banregio', value: 'Banregio'}, // for agro only
    /*
    */
  ]

  utilitySelect = [
    {name: 'Seleccione una opción', value: ''},
    {name: 'Sólo ingresos', value: 'income'},
    {name: 'Sólo egresos', value: 'outcome'},
    {name: 'Ingresos y egresos', value: 'both'}
  ]

  valueToName = {
    income: 'Sólo ingresos',
    outcome: 'Sólo egresos',
    both: 'Ingresos y egresos'
  }
}

export class Currency {
  long: string;
  short: string;
  fullName: string;
  constructor(long, short){
    this.long = long;
    this.short = short;
    this.fullName = `${long} - ${short}`;
  }
}
